const styles = theme => ({
  label: {
    color: theme.palette.primary.foreground,
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '21px',
    margin: '0 0 8px 0',
  },

  select: {
    padding: '10px 10px 10px 10px !important',
    border: `1px solid ${theme.palette.primary.borderColor} !important`,
    boxShadow: 'none !important',
    borderRadius: '0px',
    '&:focus': {
      border: `1px solid ${theme.palette.primary.borderColor} !important`,
      boxShadow: 'none !important',
    },

    '& > p': {
      color: theme.palette.secondary.disableLightGray,
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '18px',
      textTransform: 'lowercase',
    },

    '& > svg': {
      color: '#2F3239',
      width: '18px',
      height: '18px',
    },

    '& > button': {
      width: '18px',
      height: '18px',
      '& .MuiIconButton-label': {
        width: '100%',
        height: '100%',
        '& svg': {
          width: '100%',
          height: '100%',
        },
      },
      '& .MuiTouchRipple-root': {
        display: 'none',
      },
    },
  },

  selected: {
    '& > p': {
      color: '#2F3239',
      fontWeight: '500',
    },
  },

  dropdown: {
    width: '100%',
    borderRadius: '0',
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.1)',
    '& > div': {
      borderRadius: '0px',
    },

    '& ul li > div': {
      padding: '12px 14px',
      '& > p': {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
        textTransform: 'lowercase !important',
        '&:first-line': {
          textTransform: 'capitalize !important',
        },
      },
    },
  },

  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  selectedItemsContainer: {
    marginTop: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: '8px',
  },

  selectedItem: {
    background: theme.palette.primary.grey,
    padding: '8px 12px',
    borderRadius: '0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& $selectedItemLabel': {
      color: '#2F3239',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '18px',
      margin: '0',
    },

    '& $cancelIcon': {
      width: '18px',
      height: '18px',
      color: '#2F3239',
      marginLeft: '12px',
      fontSize: '0',
    },
  },

  selectedItemLabel: {},
  cancelIcon: {},
});

export default styles;
